export default __webpack_public_path__ + "static/media/readinglist.a32db598.svg";